import { Loader2 } from 'lucide-react'

interface LoadingScreenProps {
  title?: string;
  description?: string;
  className?: string;
}

export function LoadingScreen({ title, description, className }: LoadingScreenProps = {}) {
  return (
    <div className={`flex h-screen w-full items-center justify-center ${className || ''}`}>
      <div className="flex flex-col items-center space-y-4">
        <div className="relative">
          <div className="h-24 w-24 rounded-full bg-gradient-primary animate-pulse" />
          <Loader2 className="absolute inset-0 m-auto h-12 w-12 animate-spin text-white" />
        </div>
        <p className="text-lg font-medium text-muted-foreground animate-pulse">
          {title || 'Loading AppAcademia...'}
        </p>
        {description && <p className="text-sm text-muted-foreground">{description}</p>}
      </div>
    </div>
  )
}